module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips-auto-mask"
  }, [_c('div', {
    staticClass: "tips-auto-wrapper",
    class: {
      'tips-auto-show': _vm.opacityShow, 'tips-auto-hide': !_vm.opacityShow
    }
  }, [_c('div', {
    staticClass: "tips-auto-icon",
    class: _vm.tipsAutoIco
  }), _vm._v(" "), _c('div', {
    staticClass: "tips-auto-font"
  }, [_vm._v(_vm._s(_vm.tipsFont))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-095f1e62!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TipsAutoHasMiddleStyle.vue
// module id = 531
// module chunks = 1